import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import ScrollToTop from "@/components/ScrollToTop";
import ScrollTopButton from "@/components/ScrollTopButton";
import Landing from "@/pages/Landing";
import Rooms from "@/pages/Rooms";
import Booking from "@/pages/Booking";
import MyBookings from "@/pages/MyBookings";
import AdminDashboard from "@/pages/AdminDashboard";
import Beats from "@/pages/Beats";
import Login from "@/pages/Login";
import StudioTimePrivacy from "@/pages/StudioTimePrivacy";
import Apps from "@/pages/Apps";
import MiniPlayer from "@/components/MiniPlayer";
import { PlayerProvider, usePlayer } from "@/context/PlayerContext";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <div className="h-10 w-10 border-2 border-[#D90429] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/studios" element={<Rooms />} />
      <Route path="/beats" element={<Beats />} />
      <Route path="/apps" element={<Apps />} />
      <Route path="/book" element={<Booking />} />
      <Route path="/login" element={<Login />} />
      <Route path="/apps/studiotime/privacy-policy" element={<StudioTimePrivacy />} />
      <Route path="/dashboard" element={<Protected><MyBookings /></Protected>} />
      <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function PlayerShell() {
  const { track } = usePlayer();
  return (
    <>
      <div className={`mx-auto w-full max-w-[1200px] min-h-screen bg-[#0A0A0A] border-x border-white/5 relative ${track ? "pb-28 md:pb-32" : ""}`}>
        <AppRouter />
      </div>
      <ScrollTopButton raised={!!track} />
      <MiniPlayer />
    </>
  );
}

function App() {
  return (
    <div className="App bg-black">
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <ScrollToTop />
            <PlayerShell />
            <Toaster position="top-center" theme="dark" />
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
